import { defineStore } from 'pinia'
import { useLocale } from '@library/composables'
import type { RtnCode } from '@library/enums'
import type { ErrorMessageList } from '@library/models/error-message-list'
import { stringTemplate } from '@library/utils/functions'

export interface FormatErrorMessageOption {
  rtnCode?: RtnCode
  data?: Record<string, any> | null
}

export const useErrorMessageListStore = defineStore(
  'error-message-list',
  () => {
    const { apiLang } = useLocale()

    const errorMessageList = ref<ErrorMessageList[]>([])

    const errorMessageData = computed((): Record<number, string> => {
      return errorMessageList.value.reduce(
        (prev, current) => {
          const message: string =
            current.messageList.find(({ lang }) => lang === apiLang.value)
              ?.message ?? ''
          prev[current.rtnCode] = message

          return prev
        },
        {} as Record<number, string>
      )
    })

    const formatErrorMessage = (option: FormatErrorMessageOption): string => {
      const { data, rtnCode } = option

      if (!rtnCode) {
        return ''
      }

      return stringTemplate(errorMessageData.value[rtnCode] ?? '', data)
    }

    const setErrorMessageList = (data: ErrorMessageList[]) => {
      errorMessageList.value = data
    }

    return {
      setErrorMessageList,
      formatErrorMessage
    }
  }
)
